/* section-bbb-footer.js — robust marquee for the BBB footer ticker.
   Clones the phrase to fill the container, duplicates the filled set for a seamless
   loop, and sets the animation duration from a constant px/second speed so the scroll
   speed is the same at every viewport width. Idempotent: safe to re-run on resize and
   Shopify section reloads. */
(function () {
  var MAX_CLONES = 60; // safety cap

  function fill(ticker) {
    var track = ticker.querySelector('.bbb-footer__ticker-track');
    if (!track) return;

    // Reset to a single base group so re-runs start clean.
    var groups = track.querySelectorAll('.bbb-footer__ticker-group');
    if (!groups.length) return;
    for (var i = groups.length - 1; i >= 1; i--) {
      track.removeChild(groups[i]);
    }

    var base = track.firstElementChild;
    var container = ticker.clientWidth;
    if (!container || !base.offsetWidth) return;

    // Clone the base until one "set" is at least as wide as the container.
    var guard = 0;
    while (track.scrollWidth < container && guard < MAX_CLONES) {
      track.appendChild(base.cloneNode(true));
      guard++;
    }

    var setWidth = track.scrollWidth;

    // Duplicate the whole set so scrolling by one set width loops seamlessly.
    var setNodes = Array.prototype.slice.call(track.children);
    for (var j = 0; j < setNodes.length; j++) {
      track.appendChild(setNodes[j].cloneNode(true));
    }

    var speed = parseFloat(ticker.getAttribute('data-speed')) || 90; // px per second
    track.style.setProperty('--bbb-ticker-shift', setWidth + 'px');
    track.style.animationDuration = (setWidth / speed).toFixed(2) + 's';
  }

  function initAll(scope) {
    var root = scope || document;
    var tickers = root.querySelectorAll('.bbb-footer__ticker');
    for (var i = 0; i < tickers.length; i++) fill(tickers[i]);
  }

  var raf;
  function onResize() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { initAll(document); });
  }

  if (document.readyState !== 'loading') {
    initAll(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  }

  // Widths change once the display font loads.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { initAll(document); });
  }

  window.addEventListener('resize', onResize);

  // Theme editor: re-init when this section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
